export const KEYBOARD_SHORTCUT_COMMANDS = {
  OPEN_ORG_OR_SITE_SELECTION_DROPDOWN: 'OPEN_ORG_OR_SITE_SELECTION_DROPDOWN'
} as const;

export const OPEN_SITE_SELECTION_SHORTCUT_KEYS = {
  BUILDING: 'b',
  ORGANIZATION: 'o'
} as const;

// Shared keyboard event.key values used in CPM shortcut guards.
export enum ShortcutKey {
  ESCAPE = 'Escape'
}

// Shared keyboard event.code values used in CPM shortcut guards.
export enum ShortcutCode {
  ESCAPE = 'Escape'
}
